import { UNKNOWN_INPUT_TYPE } from '@/common/constants';
import * as TYPES from './types';
import util from '@/common/util';

// import { searchCenter } from './isSearchCenter';
import {
    REMOVE_KEYWORD_MUTATION,
    MAP_CHANGE_MUTATION
} from '../../md-search/_store/common';
const common = {
    [TYPES.CLEAR_ALL_CONDITION]({ commit }) {
        commit(REMOVE_KEYWORD_MUTATION);
        commit(MAP_CHANGE_MUTATION, {
            mapPath: null,
            mapSearch: false,
            mapRadius: null
        });
        commit(TYPES.CLEAR_CONDITION);
    }
};
const actions = {
    ...common
};
const centerActions = {
    ...common,
    [TYPES.CENTER_COMMIT_CONDITION]({ state, commit }) {
        const {
            searchConfigMap,
            computedPresetFilter
            // outsideFields
        } = state;
        if (util.isEmpty(searchConfigMap)) {
            return;
        }

        commit(`${TYPES.CENTER_RESET_CONDITION}`);

        Object.entries(computedPresetFilter).forEach(([name, value]) => {
            if (name in searchConfigMap) {
                const config = searchConfigMap[name];
                const { inputType } = config;
                if (inputType === 'suggestion') {
                    value = Object.keys(value).reduce((memo, type) => {
                        const items = value[type];
                        items.forEach(i => {
                            memo.push(`${type}:${i}`);
                        });
                        return memo;
                    }, []);
                }
                commit(`${TYPES.CENTER_UPDATE_CONDITION}`, {
                    name,
                    data: {
                        value,
                        inputType
                    }
                });
            } else {
                commit(`${TYPES.CENTER_UPDATE_CONDITION}`, {
                    name,
                    data: {
                        value,
                        inputType: UNKNOWN_INPUT_TYPE
                        // inMore: true
                    }
                });
            }
        });
    },
    [TYPES.CENTER_UPDATE_KEYWORD_CONDITION]({ state, commit }, payload) {
        const { name, data } = payload;
        const origin =
            (state.conditions[name] && state.conditions[name].value) || [];
        const value = data.value;
        if (!origin.includes(value) && value !== '') {
            origin.push(value);
            commit(`${TYPES.CENTER_UPDATE_CONDITION}`, {
                name,
                data: {
                    ...data,
                    value: origin
                }
            });
        }
    },
    [TYPES.CENTER_UPDATE_DEFAULT_CONDITION]({ state, commit }, payload) {
        const { name, data } = payload;
        const value = data.value;
        if (value === '') {
            commit(`${TYPES.CENTER_DEL_CONDITION}`, name);
        } else {
            commit(`${TYPES.CENTER_UPDATE_CONDITION}`, payload);
        }
    },
    [TYPES.CENTER_UPDATE_ARRAY_CONDITION]({ state, commit }, payload) {
        const { name, data } = payload;
        const value = data.value;
        if (value.length === 0) {
            commit(`${TYPES.CENTER_DEL_CONDITION}`, name);
        } else {
            commit(`${TYPES.CENTER_UPDATE_CONDITION}`, payload);
        }
    },
    [TYPES.CENTER_UPDATE_INPUT_BOX_CONDITION]({ state, commit }, payload) {
        const { name, data } = payload;
        const value = data.value;
        if (!value || value === ',') {
            commit(`${TYPES.CENTER_DEL_CONDITION}`, name);
        } else {
            commit(`${TYPES.CENTER_UPDATE_CONDITION}`, payload);
        }
    }
};
export default ({ searchCenter }) => {
    return {
        ...(searchCenter ? centerActions : actions)
    };
};
